module.exports = {"app.components.Toast.header":"This is the Toast component !","app.containers.PrivacySettings.header":"This is PrivacySettings container !","privacySettings.components.cancel":"Cancel","privacySettings.components.option1":"First name with first initial (e.g. John S.)","privacySettings.components.option2":"Initials only (e.g. JS)","privacySettings.components.option3":"Initials with surname first (e.g. SJ)","privacySettings.components.pageTitle":"Privacy settings","privacySettings.components.save":"Save","privacySettings.components.studentNameDisplay":"Student name display"}


//////////////////
// WEBPACK FOOTER
// ./app/translations/en.json
// module id = 834
// module chunks = 3